export default "__VITE_ASSET__kwY2_HGy__"